import { render, staticRenderFns } from "./SortIcon.vue?vue&type=template&id=f54ef4e0&scoped=true"
import script from "./SortIcon.vue?vue&type=script&lang=ts"
export * from "./SortIcon.vue?vue&type=script&lang=ts"
import style0 from "./SortIcon.vue?vue&type=style&index=0&id=f54ef4e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54ef4e0",
  null
  
)

export default component.exports